export default __webpack_public_path__ + "static/media/ntorq-125-moto.bd9e2305.png";